var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { RendererFactory } from "survey-core";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { SurveyQuestionDropdown } from "./reactquestion_dropdown";
import { SurveyQuestionOptionItem } from "./dropdown-item";
import { SvgIcon } from "./components/svg-icon/svg-icon";
var SurveyQuestionDropdownSelect = /** @class */ (function (_super) {
    __extends(SurveyQuestionDropdownSelect, _super);
    function SurveyQuestionDropdownSelect(props) {
        return _super.call(this, props) || this;
    }
    SurveyQuestionDropdownSelect.prototype.renderSelect = function (cssClasses) {
        var _this = this;
        var click = function (event) {
            _this.question.onClick(event);
        };
        var keyup = function (event) {
            _this.question.onKeyUp(event);
        };
        var selectElement = this.isDisplayMode ? (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        React.createElement("div", { id: this.question.inputId, className: this.question.getControlClass(), disabled: true }, this.question.readOnlyText)) :
            (React.createElement("select", { id: this.question.inputId, className: this.question.getControlClass(), ref: function (select) { return (_this.setControl(select)); }, autoComplete: this.question.autocomplete, onChange: this.updateValueOnEvent, onInput: this.updateValueOnEvent, onClick: click, onKeyUp: keyup, "aria-required": this.question.a11y_input_ariaRequired, "aria-label": this.question.a11y_input_ariaLabel, "aria-invalid": this.question.a11y_input_ariaInvalid, "aria-errormessage": this.question.a11y_input_ariaErrormessage, required: this.question.isRequired },
                this.question.allowClear ? (React.createElement("option", { value: "" }, this.question.placeholder)) : null,
                this.question.visibleChoices.map(function (item) { return React.createElement(SurveyQuestionOptionItem, { key: item.uniqueId, item: item }); })));
        return (React.createElement("div", { className: cssClasses.selectWrapper },
            selectElement,
            this.createChevronButton()));
    };
    SurveyQuestionDropdownSelect.prototype.createChevronButton = function () {
        if (!this.question.cssClasses.chevronButtonIconId)
            return null;
        return (React.createElement("div", { className: this.question.cssClasses.chevronButton, "aria-hidden": "true", onPointerDown: this.chevronPointerDown },
            React.createElement(SvgIcon, { className: this.question.cssClasses.chevronButtonSvg, iconName: this.question.cssClasses.chevronButtonIconId, size: "auto" })));
    };
    return SurveyQuestionDropdownSelect;
}(SurveyQuestionDropdown));
export { SurveyQuestionDropdownSelect };
ReactQuestionFactory.Instance.registerQuestion("sv-dropdown-select", function (props) {
    return React.createElement(SurveyQuestionDropdownSelect, props);
});
RendererFactory.Instance.registerRenderer("dropdown", "select", "sv-dropdown-select");
